import React from "react";
import PropTypes from "prop-types";

import Button from "@gcs/design-system/react/components/Button";

import useWindowSize from "hooks/useWindowSize";

import * as S from "./ModalResponsive.style";

const ModalResponsive = (props) => {
  const { width } = useWindowSize();
  const isMobile = width && width <= 992;

  const handleToggle = () => {
    if (props?.onClose) {
      props.onClose();
    }
  };

  return (
    <S.ModalResponsive {...props}>
      <S.ModalResponsiveHeader>
        {props?.subTitle ? (
          <S.ModalResponsiveSpan>{props?.subTitle}</S.ModalResponsiveSpan>
        ) : null}

        <S.ModalResponsiveTitle>{props?.title}</S.ModalResponsiveTitle>
      </S.ModalResponsiveHeader>

      <S.ModalResponsiveBody>{props?.body}</S.ModalResponsiveBody>

      <S.ModalResponsiveFooter>
        <Button variant={isMobile ? "text" : "outlined"} onClick={handleToggle}>
          Fechar
        </Button>
      </S.ModalResponsiveFooter>
    </S.ModalResponsive>
  );
};

ModalResponsive.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  body: PropTypes.element,
};

ModalResponsive.defaultProps = {};

export default ModalResponsive;
